import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BaseDirective } from 'src/app/shared/base.directive';

@Component({
  selector: 'an-action-field',
  templateUrl: './action-field.component.html',
  styleUrls: ['./action-field.component.scss']
})
export class ActionFieldComponent extends BaseDirective {
    /** Name of the field */
    @Input() public name: string;
    /** Value to display on the field */
    @Input() public placeholder: string;
    /** Emitter for user interaction events */
    @Output('onAction') public on_action = new EventEmitter();
    /** Whether to show tooltip */
    public show_tooltip = false;

    /**
     * Emit that the user has performed an action on the field
     */
    public performAction() {
        this.show_tooltip = !this.show_tooltip;
        this.on_action.emit();
    }
}
